import React from "react";
import images from "../../constants/images";
import {
  AboutContainer,
  Bold,
  FounderCard,
  FounderDescription,
  FounderImage,
  FounderName,
  FounderRole,
  FoundersContainer,
  FoundersSection,
  Highlight,
  JourneyItem,
  JourneyItemSpan,
  JourneyList,
  JourneySection,
  MissionContainer,
  MissionText,
  MissionTitle,
  SectionTitle,
  SocialProofContainer,
  StatBox,
  StatLabel,
  StatNumber,
  StatsContainer,
  TimelineMarker,
} from "./About.styled";

const stats = [
  { label: "Survey Responders", value: 120, suffix: "+" },
  { label: "Interviews", value: 10, suffix: "+" },
  { label: "Would Download", value: 80, suffix: "%" },
];

const founders = [
  {
    name: "Daniel",
    role: "Developer & Communications Lead",
    image: images.daniel,
    description: "Bachelor's Business Information Technology",
  },
  {
    name: "Diego",
    role: "Developer & Operations Officer",
    image: images.diego,
    description: "Bachelor's Business Information Technology",
  },
  {
    name: "Tudor",
    role: "Head Developer",
    image: images.tudor,
    description: "Bachelor's Computer Science",
  },
  {
    name: "Ricky",
    role: "External Affairs",
    image: images.ricky,
    description: "Bachelor's International Business Administration",
  },
  {
    name: "Ali",
    role: "Accounting & Treasury",
    image: images.ali,
    description: "Bachelor's International Business Administration",
  },
];

const timeline = [
  "Apr 2025: UT Challange participants",
  "Feb 2025: Joined Novel-T START Programme",
  "Dec 2024: Gathered market validation through surveys & interviews",
  "Nov 2024: Guerilla marketing campaign in UT campus",
  "Nov 2024: First prototype of the application done",
  "Oct 2024: Launched business model & got to work!",
];

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
      staggerChildren: 0.3,
    },
  },
};

const About = () => {
  return (
    <AboutContainer>
      <MissionContainer
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeIn}
      >
        <MissionTitle>Our Mission</MissionTitle>
        <MissionText>
          At <Highlight>Open for Conversation</Highlight>, we believe that our
          location-based, gamified platform helps (international) students who
          want to make connections by mitigating{" "}
          <Highlight>social awkwardness</Highlight>, and creating opportunities
          for <Bold>meaningful interactions</Bold>, unlike traditional social
          platforms.
        </MissionText>
      </MissionContainer>

      <SocialProofContainer
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeIn}
      >
        <SectionTitle>Market Validation</SectionTitle>
        <StatsContainer>
          {stats.map((stat, index) => (
            <StatBox
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 + index * 0.2 }}
            >
              <StatNumber
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 1, delay: 0.5 + index * 0.2 }}
              >
                {stat.value}
                {stat.suffix}
              </StatNumber>
              <StatLabel>{stat.label}</StatLabel>
            </StatBox>
          ))}
        </StatsContainer>
      </SocialProofContainer>

      <FoundersSection
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeIn}
      >
        <SectionTitle>Meet Our Founders</SectionTitle>
        <FoundersContainer
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={{
            hidden: { opacity: 0 },
            visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
          }}
        >
          {founders.map((founder, index) => (
            <FounderCard
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              key={index}
              variants={fadeIn}
              whileHover={{ scale: 1.05 }}
            >
              <FounderImage src={founder.image} alt={founder.name} />
              <FounderName>{founder.name}</FounderName>
              <FounderRole>{founder.role}</FounderRole>
              <FounderDescription>{founder.description}</FounderDescription>
            </FounderCard>
          ))}
        </FoundersContainer>
      </FoundersSection>

      <JourneySection
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeIn}
      >
        <SectionTitle>Our Journey</SectionTitle>
        <JourneyList>
          {timeline.map((event, index) => (
            <JourneyItem key={index} variants={fadeIn}>
              <TimelineMarker />
              <JourneyItemSpan>{event}</JourneyItemSpan>
            </JourneyItem>
          ))}
        </JourneyList>
      </JourneySection>
    </AboutContainer>
  );
};

export default About;
